import type { ModalComponentProps } from "@/lib/modal";
import { ConfirmationModal } from "@/components/modals/confirmation-modal";
import { useRemoveMember } from "@/lib/api/teams";
import type { TeamMember } from "@/lib/api/types";

export interface RemoveMemberModalProps {
  tenantId: string;
  member: TeamMember;
}

export function RemoveMemberModal({
  tenantId,
  member,
  onClose,
}: RemoveMemberModalProps & ModalComponentProps) {
  const removeMember = useRemoveMember(tenantId);

  const handleRemove = () => {
    removeMember.mutate(member.userId, {
      onSuccess: () => onClose(),
    });
  };

  return (
    <ConfirmationModal
      title="Remove member"
      description={`Are you sure you want to remove ${member.userName} from this team? They will lose access to all team resources.`}
      confirmLabel="Remove"
      pendingLabel="Removing..."
      onConfirm={handleRemove}
      isPending={removeMember.isPending}
      onClose={onClose}
    />
  );
}

RemoveMemberModal.displayName = "RemoveMemberModal";
